module.exports = __webpack_public_path__ + "img/shoubingjigou.asm.622b80c0.jpg";